module.exports = __webpack_public_path__ + "img/payment-qris.70c7f40e.png";